import { getCompanyConfig, inIframe } from "@utils"
import { gima } from "gima-common"
// You can customize the template with the help of this file

//Template config options
const themeConfig = {
  app: {
    appName: 'CMS',
    appNameUnbreak: `CMS`,
    appLogoImage: getCompanyConfig()?.company_Logo || require('@src/assets/images/logo/logo.svg').default,
    appsilkReloLogo: getCompanyConfig()?.company_Logo || require('@src/assets/images/logo/logo.png').default
  },
  returnUrl: localStorage.getItem("returnUrl") || '/guides/',
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: gima.getThemeColor() || "#8dc454" // BS color options [primary, success, etc]
    },
    footer: {
      type: inIframe() ? 'static' : 'floating' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  }
}

export default themeConfig
